/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface FlightCheckoutFailure
 */
export interface FlightCheckoutFailure {
    /**
     *
     * @type {string}
     * @memberof FlightCheckoutFailure
     */
    code: string;
    /**
     *
     * @type {string}
     * @memberof FlightCheckoutFailure
     */
    message: string;
    /**
     *
     * @type {boolean}
     * @memberof FlightCheckoutFailure
     */
    retryable: boolean;
}

/**
 * Check if a given object implements the FlightCheckoutFailure interface.
 */
export function instanceOfFlightCheckoutFailure(value: object): value is FlightCheckoutFailure {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('retryable' in value) || value['retryable'] === undefined) return false;
    return true;
}

export function FlightCheckoutFailureFromJSON(json: any): FlightCheckoutFailure {
    return FlightCheckoutFailureFromJSONTyped(json, false);
}

export function FlightCheckoutFailureFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightCheckoutFailure {
    if (json == null) {
        return json;
    }
    return {

        'code': json['code'],
        'message': json['message'],
        'retryable': json['retryable'],
    };
}

export function FlightCheckoutFailureToJSON(json: any): FlightCheckoutFailure {
    return FlightCheckoutFailureToJSONTyped(json, false);
}

export function FlightCheckoutFailureToJSONTyped(value?: FlightCheckoutFailure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'code': value['code'],
        'message': value['message'],
        'retryable': value['retryable'],
    };
}
